import apiFetch from '@wordpress/api-fetch'
import Rellax from 'rellax'
import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
export default class Home {
    constructor() {
        Home.parallax_init()
        Home.strate_1_slider().then(() => {
            Home.agenda_engine()
            Home.instagram_wall()
        })
    }

    static parallax_init() {
        $(window).on('load', () => {
            const rellax = new Rellax('.rellax')
        })
    }

    static async strate_1_slider() {
        const slider_img = '[data-id="wpiris-strate-1-slider-img"]'
        const slider_img_wrapper = '[data-id="wpiris-strate-1-slider-img-wrapper"]'
        const slider_img_item = '[data-id="wpiris-strate-1-slider-img-item"]'
        const slider_content = '[data-id="wpiris-strate-1-slider-content"]'
        const slider_content_wrapper = '[data-id="wpiris-strate-1-slider-content-wrapper"]'
        const slider_content_item = '[data-id="wpiris-strate-1-slider-content-item"]'

        if ($(slider_img).length > 0 && $(slider_content).length > 0) {
            Home.add_swiper_class($(slider_img), $(slider_img_wrapper), $(slider_img_item))
            Home.add_swiper_class(
                $(slider_content),
                $(slider_content_wrapper),
                $(slider_content_item),
            )

            const swiper_img = await Swiper.create(slider_img, {
                mousewheel: {
                    forceToAxis: true,
                },
                loop: false,
                lazy: true,
                navigation: {
                    nextEl: '.swiper-strate-1-button-next',
                    prevEl: '.swiper-strate-1-button-prev',
                },
                pagination: {
                    el: '.swiper-strate-1-pagination',
                    clickable: true,
                },
                slidesPerView: 1,
                speed: 1000,
                breakpoints: {
                    0: {
                        spaceBetween: 20,
                        slidesPerView: 1.1,
                    },
                    651: {
                        spaceBetween: 60,
                        slidesPerView: 1.1,
                    },
                    1001: {
                        spaceBetween: 530,
                        slidesPerView: 1,
                    },
                },
            })

            const swiper_content = await Swiper.create(slider_content, {
                mousewheel: {
                    forceToAxis: true,
                },
                loop: false,
                lazy: true,
                slidesPerView: 1,
                speed: 1000,
                breakpoints: {
                    0: {
                        spaceBetween: 20,
                        slidesPerView: 1.1,
                    },
                    651: {
                        spaceBetween: 60,
                        slidesPerView: 1.1,
                    },
                    1001: {
                        spaceBetween: 20,
                        slidesPerView: 1,
                    },
                },
            })

            swiper_content.controller.control = swiper_img
            swiper_img.controller.control = swiper_content
        }
    }

    static add_swiper_class(container, wrapper, item) {
        $(container).addClass('swiper-container')
        $(wrapper).addClass('swiper-wrapper')
        $(item).addClass('swiper-slide')
    }

    static agenda_engine() {
        const triggers = $('[data-trigger="wpiris-filter-agenda"]')

        triggers.each(function () {
            const trigger = $(this)
            const type = trigger.data('type')
            const value = `${trigger.data('val')}`
            let types = null
            let values = null

            if (type.indexOf('|') > -1) {
                types = type.split('|')
            }

            if (value.indexOf('|') > -1) {
                values = value.split('|')
            }

            trigger.click((e) => {
                e.preventDefault()

                if (types && values) {
                    $(types).each(function (i) {
                        $(`#agenda-${this}`).val(values[i])
                    })
                } else {
                    $(`#agenda-${type}`).val(value)
                }

                $('#agendaForm').submit()
            })
        })

        $('.iris-card-agenda__date__month').each(function () {
            this.innerHTML = this.innerHTML.replace('.', '')
        })
    }

    static instagram_wall() {
        const social_wall = '[data-id="social-wall"]'

        if ($(social_wall).length > 0) {
            const limit = window.matchMedia('(min-width: 1001px)').matches
                ? 4
                : window.matchMedia('(min-width: 651px)').matches
                  ? 3
                  : 1
            apiFetch({
                path: IRISCollectionCustomer.irisSsoInstagramPath,
                method: 'POST',
                data: { limit: limit },
            })
                .then((result) => {
                    $(social_wall).html(result.render)
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                    ).then(({ HcLazyload }) => {
                        HcLazyload.update()
                    })
                })
                .catch(() => {
                    $(social_wall).html('')
                })
        }
    }
}
